import Fuse, { IFuseOptions } from 'fuse.js';
import { TConsumerItem } from '../../../types/data';

/**
 * Shared fuzzy tuning: the filter and the highlight (see `useSearchHighlight`) must agree on
 * what counts as a match, otherwise a found item would stay unpainted.
 */
export const FUZZY_MATCH_OPTIONS = {
    // 2 ошибки
    threshold: 0.4,
    ignoreLocation: true,
};

const FUSE_OPTIONS: IFuseOptions<TConsumerItem> = {
    ...FUZZY_MATCH_OPTIONS,
    keys: ['title', 'alias'],
};

/**
 * Filters items by a fuzzy match on title/alias. Matched text is left untouched —
 * the visual highlight is painted by the CSS Custom Highlight API (see `useSearchHighlight`).
 *
 * `isFiltering: false` means the list was already filtered on the server, so all items pass through.
 */
export const filterBySearch = (search: string, items?: TConsumerItem[], isFiltering = true): TConsumerItem[] => {
    if (!items) return [];
    if (!isFiltering) return items;

    const fuse = new Fuse(items, FUSE_OPTIONS);
    return fuse.search(search).map(({ item }) => item);
};
